import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import { Link } from 'react-router-dom';
import dateformat from 'dateformat';
import { Row, Col} from 'react-bootstrap';
import Truncate from 'src/components/truncate';

import styles from './CollectionSearchView.module.scss';
import LockIcon from 'src/legacy/components/LockIcon';

import CollectionDefaultIcon from "src/legacy/images/default_group.jpg";
import DOMPurify from 'dompurify';

import { localizedStrings } from 'src/localization';
import _ from 'lodash';

class CollectionSearchView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedKeywords = localizedStrings.keywords;
  }

  render() {
    const collection = this.props.collection;

    return (
      <Row className={cx(styles.collection, this.props.className)}>
        <Col md={12} className={styles.paddingRight}>
          <Link to={`/collections/${collection.id}`} className={styles.collectionLink}>
            <div className={styles.collectionContainer}>
              <div align="bottom" className={styles.collectionIcon}>
                {this.renderCollectionIcon()}
              </div>
              <div className={styles.details}>
                <div className={styles.name}>
                <Truncate width={150}>
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(collection.name)}}></div>
                </Truncate>
                </div>
                <Col sm={12} className={cx(styles.metrics, styles.noPadding)}>
                  <span>{collection.assetsCount} { this.localizedKeywords.assets } </span>
                </Col>
                <Col sm={12} className={cx(styles.author, styles.noPadding)}>
                  <Truncate lines={2}>{ this.localizedCommons.owner }: {this.renderName(collection.createdBy)}</Truncate>
                </Col>
                <Col sm={12} className={cx(styles.date, styles.noPadding, styles.italicText)}>
                  <span>{ this.localizedCommons.last_update }: {dateformat(collection.modifiedDate, 'dd mmm yyyy')}</span>
                </Col>
              </div>
            </div>
          </Link>
        </Col>
      </Row>
    );
  }

  renderName(user) {
    return `${user.firstName || ''} ${user.lastName || ''}`
  }

  renderCollectionIcon() {
    const collection = this.props.collection;

    var icon = CollectionDefaultIcon;

    if (collection.icon) {
      icon = collection.icon.thumbnail;
    }

    let layerStyle = {
      width: this.props.iconWidth,
      height: this.props.iconWidth * 0.7153,
    };

    let iconStyle = {
      ...layerStyle,
      'backgroundImage': `url(${icon})`,
      'marginLeft': "15px",
    };

    let folderStyle = {
      height: (this.props.iconWidth * 1.1667) + 10
    };

    return (
      <div className={cx(styles.folio, styles.animated)}>
        <div className={styles.icon}>
          <div style={folderStyle} className={styles.folder}>
            <div style={iconStyle} className={cx(styles.layer, styles.cover)}>
            {_.get(this.props,"collection.internal") &&
                  <div className={styles.internalCollection}>
                    <LockIcon direction="left" />
                  </div>
                }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CollectionSearchView;